import { render, staticRenderFns } from "./WkResourceExportsStatus.page.vue?vue&type=template&id=d6eea0a2"
import script from "./WkResourceExportsStatus.page.vue?vue&type=script&lang=ts"
export * from "./WkResourceExportsStatus.page.vue?vue&type=script&lang=ts"
import style0 from "./WkResourceExportsStatus.page.vue?vue&type=style&index=0&id=d6eea0a2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports